import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApplicationInitializationService } from './application-initialization.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };
  constructor(
    private http: HttpClient,
    private AppInit: ApplicationInitializationService
  ) { }
  geteInitiativeCampaignsData(): boolean {
      if (this.AppInit.environmentConfig.EINITIATIVE_PLANT_A_TREE_EVENT_ENABLE == 'TRUE') {
        return true;
      }
      else {
        return false;
      }
  }

}
